import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

import { TrialExpirationBanner } from "@/components/trial-expiration-banner";

import { MainSideNav } from "../components/sidebar/sidebar.tsx";

export const HomeLayout = () => {
  return (
    <Flex className="flex-col w-screen max-h-screen h-screen">
      <TrialExpirationBanner />
      <Flex className="w-full h-full overflow-hidden">
        <MainSideNav />
        <Outlet />
      </Flex>
    </Flex>
  );
};
